// extracted by mini-css-extract-plugin
module.exports = {"list":"ListProducts_list__XomVv","listContainer":"ListProducts_listContainer__2Hxrh"};